export default __webpack_public_path__ + "static/media/trash.6006b6f4.svg";